import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../store/AppContext';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiFolder, FiChevronRight } from 'react-icons/fi';
import { motion } from 'framer-motion';

const Clients = () => {
  const { data, setData, t } = useAppContext();
  const [isAdding, setIsAdding] = useState(false);
  const [newClientName, setNewClientName] = useState('');

  const handleAdd = (e) => {
    e.preventDefault();
    if (!newClientName.trim()) return;
    const newClient = {
      id: `c_${Date.now()}`,
      name: newClientName,
      websites: []
    };
    setData(prev => ({ ...prev, clients: [...prev.clients, newClient] }));
    setNewClientName('');
    setIsAdding(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-slate-800">{t('clients')}</h1>
        <button 
          onClick={() => setIsAdding(!isAdding)}
          className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
        >
          <SafeIcon icon={FiPlus} /> {t('addClient')}
        </button>
      </div>

      {isAdding && (
        <motion.form 
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          onSubmit={handleAdd} 
          className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm"
        >
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="block text-sm font-medium text-slate-700 mb-1">{t('clientName')}</label>
              <input 
                type="text" 
                value={newClientName}
                onChange={(e) => setNewClientName(e.target.value)}
                className="w-full border border-slate-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                autoFocus
              />
            </div>
            <button type="submit" className="bg-slate-800 text-white px-6 py-2 rounded-lg hover:bg-slate-900">{t('save')}</button>
            <button type="button" onClick={() => setIsAdding(false)} className="bg-slate-100 text-slate-600 px-6 py-2 rounded-lg hover:bg-slate-200">{t('cancel')}</button>
          </div>
        </motion.form>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {data.clients.map(client => (
          <Link key={client.id} to={`/clients/${client.id}`}>
            <motion.div 
              whileHover={{ y: -4 }}
              className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all group"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="p-3 bg-blue-50 rounded-lg text-blue-600">
                  <SafeIcon icon={FiFolder} className="text-xl" />
                </div>
                <SafeIcon icon={FiChevronRight} className="text-slate-400 group-hover:text-indigo-500 transition-colors" />
              </div>
              <h3 className="text-lg font-semibold text-slate-800 mb-1">{client.name}</h3>
              <p className="text-sm text-slate-500">{client.websites?.length || 0} {t('websites')}</p>
            </motion.div>
          </Link>
        ))}
        {data.clients.length === 0 && !isAdding && (
          <div className="col-span-full py-12 text-center text-slate-500 bg-white rounded-xl border border-dashed border-slate-300">
            {t('noData')}
          </div>
        )}
      </div>
    </div>
  );
};

export default Clients;